import { Box, Typography } from '@mui/material';

import { ProgressBar } from '@/components';
import { formatNumber } from '@/utils';

interface SeatCapProgressIndicatorProps {
  count?: number;
  cap?: number;
  showProgressBar?: boolean;
  hasError?: boolean;
}

export const SeatCapProgressIndicator = ({
  count,
  cap,
  hasError,
  showProgressBar = true,
}: SeatCapProgressIndicatorProps) => {
  if (count === undefined || cap === undefined) return null;

  return (
    <Box>
      <Typography variant="body3" color={hasError ? 'error' : 'text.secondary'}>
        {formatNumber(count)}/{formatNumber(cap)}{' '}
        <Box
          component="span"
          sx={{ display: { xs: 'none', sm: 'none', md: 'inline-block' } }}>
          Seats Filled
        </Box>
      </Typography>
      {showProgressBar && (
        <ProgressBar progressFraction={Math.max(Math.min(count / cap, 1), 0)} />
      )}
    </Box>
  );
};
